import { render, staticRenderFns } from "./DiningPromotionItem.vue?vue&type=template&id=20b9d58c&scoped=true&"
import script from "./DiningPromotionItem.vue?vue&type=script&lang=js&"
export * from "./DiningPromotionItem.vue?vue&type=script&lang=js&"
import style0 from "./DiningPromotionItem.vue?vue&type=style&index=0&id=20b9d58c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20b9d58c",
  null
  
)

export default component.exports